// ADR-133 D2: the scheduler batch this run belongs to — every declared step,
// including the ones that never started because an earlier one failed.
// Same pills as the reporting-scope filter (FilterChip): the current run is the
// filled one with a dot; the colour is the step's status.
import React from 'react';
import { Tooltip, Typography } from '@mui/material';
import FilterChip from '../../common/filters/FilterChip';
import {
  BATCH_STEP_LABELS,
  BATCH_STEP_STATUS_LABELS,
} from '../../../constants/ingestionSyncRuns';
import { StepsRow } from './styles';

// Pastel background (selected) / text + border colour per step status.
const STEP_STATUS_COLORS = {
  SUCCESS: { bg: '#E6F4EA', color: '#1E8E3E' },
  FAILED: { bg: '#FEE2E2', color: '#B91C1C' },
  RUNNING: { bg: '#DBEAFE', color: '#1E40AF' },
  SKIPPED: { bg: '#FEF3C7', color: '#92400E' },
  NOT_STARTED: { bg: '#F3F4F6', color: '#6B7280' },
};

const stepTooltip = (step) => {
  const parts = [BATCH_STEP_STATUS_LABELS[step.status] || step.status];
  if (step.attempts > 1) {
    parts.push(`${step.attempts} attempts`);
  }
  if (step.error) {
    parts.push(step.error);
  }
  return parts.join(' · ');
};

const BatchSteps = ({ batch, currentRunId, onOpenRun }) => {
  // Ingestion steps only: batches recorded before ADR-133 D2.1 may still carry
  // a BENCH_CANDIDATES step, which is not an ingestion sync.
  const steps = (Array.isArray(batch?.steps) ? batch.steps : [])
    .filter((step) => Object.prototype.hasOwnProperty.call(BATCH_STEP_LABELS, step.key));
  if (!batch || steps.length === 0) {
    return null;
  }
  return (
    <StepsRow>
      <Typography variant="body2" sx={{ color: '#64748B', mr: 1 }}>
        Batch{batch.retryAttempt > 0 ? ` (retry ${batch.retryAttempt})` : ''}:
      </Typography>
      {steps.map((step, index) => {
        const isCurrent = Boolean(step.runId) && step.runId === currentRunId;
        const canOpen = Boolean(step.runId) && !isCurrent;
        const colors = STEP_STATUS_COLORS[step.status] || STEP_STATUS_COLORS.NOT_STARTED;
        return (
          <Tooltip key={step.key || index} arrow title={stepTooltip(step)}>
            <FilterChip
              label={BATCH_STEP_LABELS[step.key] || step.key}
              isSelected={isCurrent}
              onClick={canOpen ? () => onOpenRun(step.runId) : undefined}
              backgroundColor={colors.bg}
              textColor={colors.color}
              borderColor={colors.color}
              showDot
              sx={canOpen ? undefined : { cursor: 'default' }}
            />
          </Tooltip>
        );
      })}
    </StepsRow>
  );
};

export default BatchSteps;
